<template>
  <!--    图片添加修改-->
  <div class="imageBox" v-loading="showLoading">
    <el-form ref="form" :model="images" label-width="80px">
      <div class="inputBox">
        <el-form-item label="预览图片">
          <div 
            class="upload-area" 
            @paste="handlePaste"
            @click="handleUploadThumbnailClick($event, 'file')"
            style="border: 2px dashed #d9d9d9; border-radius: 6px; padding: 10px; margin-bottom: 10px;"
          >
            <div style="color: #999; margin-bottom: 5px; font-size: 12px;">
              支持粘贴图片 (Ctrl+V) 或拖拽图片到弹窗任意位置
            </div>
            <el-upload
                class="upload-demo"
                action="none"
                multiple
                accept="image/*"
                :limit="100"
                :file-list="images.fileList"
                :on-exceed="imageCountOut"
                :on-remove="handleRemove"
                :on-change="fileChange"
                :on-preview="handleUploadPreview"
                :before-upload="beforeUpload"
                :auto-upload="false"
                list-type="picture-card">
              <el-button size="small" type="primary">
                点击选择
              </el-button>
              <div slot="tip" class="el-upload__tip">一次最多上传50张图片文件，且不超过2MB</div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item
          label-width="300"
          :label="使用图片名作为标签名">
          <el-switch
              v-model="isUseImageName"
              :active-value="true"
              :inactive-value="false"
              active-color="#67c23a"
              inactive-color="#dcdfe6">
          </el-switch>

        </el-form-item>
        <el-form-item :label="isBatchUpload ? '公共标签' : '图片标签'">
          <el-input v-model="images.tag" class="input"></el-input>&nbsp;&nbsp;
          图片热度&nbsp;&nbsp;<el-input v-model="images.heat" class="input" type="number"></el-input>
          <span v-if="imageTypes === undefined || imageTypes === null || imageTypes.length === 0">
            <el-tag style="margin-left: 20px">图片类型：{{ localImageType }}</el-tag>
          </span>
          <span v-else>
             &nbsp;图片类型:<el-select v-model="localImageType" placeholder="请选择图片类型" style="margin-left: 4px">
            <el-option
                v-for="item in imageTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          </span>
        </el-form-item>
        <el-form-item label="图片分类">
          <el-select 
            v-model="images.categoryId" 
            placeholder="请选择图片分类" 
            @change="handleCategoryChange($event)">
            <el-option label="贴图" :value="5"></el-option>
            <el-option label="模板" :value="4"></el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="模板类型" v-if="hasShowOperation()">
          <el-select v-model="images.templateType" placeholder="请选择模板类型">
            <el-option
                v-for="item in templateType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item class="btn">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :title="dialogTitle"
               @close="closeDialog"
               top="5vh"
               @opened="dialogOpen"
               :visible.sync="showDialog"
               :close-on-click-modal="false"
               width="800px"
               append-to-body
               :destroy-on-close="true"
               :fullscreen="false">
      <TemplateDataAdd v-on:saveStatus="saveStatus"
                       :templateData="templateData"
                       :id="images.id"
                       :is-title="isTitle"
                       :type="images.templateType"
                       :is-load-data="isLoadDialog"
                       :is-add-image-data="isAddImageData"
                       :is-update="isUpdateTemplateData"/>
    </el-dialog>
  </div>
</template>

<script>
import TemplateDataAdd from "./TemplateDataAdd";
import {openImagePreview, bindDialogFileDrop} from "./imageMaterialUtils";
import {stringify} from "../../../public/minigame/secha/secha_files/21287325";

export default {
  name: "SearchImageUpload",
  props: ['images', "categoryList", "isUpdate", "loadData", "imageType", "imageTypes", "isBatchUpload"],
  components: {
    TemplateDataAdd
  },
  watch: {
    loadData: function () {
    },
    imageType: function (newVal) {
      this.localImageType = newVal;
    }
  },
  data() {
    return {
      dialogTitle: "",
      showDialog: false,
      showLoading: false,
      postCount: 0,
      templateData: {},
      templateDataList: [],
      secondCategoryId: 2,
      isTitle: false,
      isUseImageName: false,
      isUpdateTemplateData: false,
      isAddImageData: false,
      isLoadDialog: false,
      localImageType: this.imageType,
      templateType: [{
        label: "图片",
        value: 0
      }, {
        label: "视频",
        value: 1
      }]
    }
  },
  created() {
    if (!this.isUpdate) {
      this.localImageType = '';
      this.$set(this.images, 'heat', 4000);
    }
  },
  methods: {
    handleUploadPreview: function (file) {
      const url = file.url || ''
      if (!url) {
        return
      }
      openImagePreview(url, file.name || '图片预览')
    },
    handleUploadThumbnailClick: function (event, listKey) {
      if (event.target.closest('.el-icon-close, .el-upload-list__item-actions, .el-upload-list__item-name, .el-button')) {
        return
      }
      if (event.target.closest('.el-upload--picture-card') && !event.target.closest('.el-upload-list__item')) {
        return
      }
      const thumb = event.target.closest('.el-upload-list__item-thumbnail')
      if (!thumb) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
      const file = this.findUploadFileByThumbnail(thumb, listKey)
      if (file) {
        this.handleUploadPreview(file)
      }
    },
    findUploadFileByThumbnail: function (thumb, listKey) {
      const list = listKey === 'material' ? this.images.materialList : this.images.fileList
      if (!list || !list.length) {
        return null
      }
      const src = thumb.getAttribute('src') || thumb.src || ''
      for (let i = 0; i < list.length; i++) {
        const fileUrl = list[i].url || ''
        if (fileUrl && (fileUrl === src || src.indexOf(fileUrl) === 0 || fileUrl.indexOf(src) === 0)) {
          return list[i]
        }
      }
      const item = thumb.closest('.el-upload-list__item')
      const listRoot = thumb.closest('.el-upload-list')
      if (!item || !listRoot) {
        return list[0]
      }
      const items = listRoot.querySelectorAll('.el-upload-list__item')
      let index = -1
      for (let j = 0; j < items.length; j++) {
        if (items[j] === item) {
          index = j
          break
        }
      }
      return index >= 0 ? list[index] : list[0]
    },
    getFontLocation: function (location) {
      switch (location) {
        case "left":
          return "左边";
        case "right":
          return "右边";
        case "center":
          return "中间";
      }
      return "";
    },
    getOperations: function (operations) {
      switch (operations) {
        case "head":
          return "换头";
        case "face":
          return "抠脸";
      }
      return "无";
    },
    //是否显示操作选项
    hasShowOperation: function () {
      if (this.isUpdate) {
        if (this.images.secondCategory != null && this.images.secondCategory.id === 2 && this.secondCategoryId === 0) {
          return true;
        } else {
          return this.secondCategoryId === 2
        }
      } else {
        return false;
      }
    },
    imageCountOut: function () {
      this.showErrorMessage("只能选择一个文件")
    },
    /**
     * 图片移除回调
     * @param file
     * @param fileList
     */
    handleRemove: function (file, fileList) {
      console.log("fileChange file " + file + " fileList " + fileList.raw)
      // 清理URL对象
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
      // this.images.files = fileList
      if (this.images.files === undefined) {
        this.images.files = []
      }
      this.images.files = this.images.files.filter(function (item, index, arr) {
        return (file.name !== item.name);
      })
      if (!this.isUpdate && this.images.files.length === 1) {
        this.tryAutoFillTagFromImageName(this.images.files[0].name)
      }
    },
    cancel: function () {
      this.$emit('saveStatus', false)
    },
    /**
     * 保存上传
     * */
    save() {
      if (!this.isUpdate) {
        this.addImage()
      } else {
        this.update()
      }
    },
    /**
     * 标签为空且只有一张图片时，用文件名自动填充标签
     * @param fileName
     */
    tryAutoFillTagFromImageName: function (fileName) {
      if (this.isUpdate || !fileName) {
        return
      }
      const tag = this.images.tag
      if (tag !== '' && tag !== undefined && tag !== null && String(tag).trim() !== '') {
        return
      }
      const dotIndex = fileName.lastIndexOf('.')
      const tagName = dotIndex > 0 ? fileName.substring(0, dotIndex) : fileName
      if (tagName) {
        this.$set(this.images, 'tag', tagName)
      }
    },
    /**
     * 图片选择回调
     * @param file
     * @param fileList
     */
    fileChange: function (file, fileList) {
      console.log("fileChange file " + file + " fileList " + fileList)
      if (!this.beforeUpload(file)) {
        return true
      }
      if (this.images.files === undefined) {
        this.images.files = []
      }
      this.images.files.push(file.raw)
      if (!this.isUpdate && this.images.files.length === 1) {
        this.tryAutoFillTagFromImageName(file.raw && file.raw.name)
      }
    },
    beforeUpload(file) {
      // const isImage = file.type.startsWith('image/');
      const size = 2;
      const isLt2M = file.size / 1024 / 1024 < size;
      console.log("beforeUpload file.type:" + file.type + " isLt2M " + isLt2M)
      // if (!isImage) {
      //   this.$message.error('上传头像图片只能是 图片（image） 格式!');
      // }
      if (!isLt2M) {
        this.$message.error(`上传头像图片大小不能超过 ${size}MB!`);
      }
      return isLt2M;
    },
    selectChange: function (data) {
      //匹配三级id
      if (data !== undefined) {
        if (data.length === 3) {
          this.images.categoryId = data[2]
        }
        if (data.length >= 2) {
          this.secondCategoryId = data[1];
        }
      }
    },
    handleCategoryChange: function (value) {
      console.log("选择变化:", value);
      const newSecondCategoryId = value === 4 ? 2 : 3;
      this.$set(this, 'secondCategoryId', newSecondCategoryId);
      this.$set(this.images, 'categoryId', value);
      console.log("secondCategoryId:", this.secondCategoryId, "categoryId:", this.images.categoryId);
      this.$forceUpdate();
    },
    /**
     * 显示错误信息弹框
     * @param msg 错误信息弹框
     */
    showErrorMessage: function (msg) {
      this.$confirm(msg, "提示", {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      })
    },
    /**
     * 上传图片
     */
    addImage: function () {
      if ((this.images.tag === '' || this.images.tag === undefined) && !this.isUseImageName) {
        this.showErrorMessage(this.isBatchUpload ? "公共标签不能为空，请输入公共标签或打开使用图片名作为标签名" : "图片名不能为空，请输入标签或者选中使用文件名")
        return
      }
      //如果没有输入标签，选中了使用文件名，标签赋值为空
      if ((this.images.tag === '' || this.images.tag === undefined) && this.isUseImageName) {
        this.images.tag = ""
      }
      if (this.images.heat === undefined || this.images.heat === "") {
        this.showErrorMessage("热度不能为空")
        return
      }
      if (this.images.categoryId === null || this.images.categoryId === undefined) {
        this.showErrorMessage("分类必须是三级分类")
        return
      }
      if (this.images.files === null) {
        this.showErrorMessage("图片不能为空")
        return
      }
      this.showLoading = true;
      const that = this;
      const params = new FormData()
      params.append("tag", this.images.tag)
      params.append("hot", this.images.heat)
      params.append("categoryId", this.images.categoryId)
      params.append("isLock", 0)
      params.append("addFileNameToTag", this.isUseImageName)
      params.append("imageType", this.localImageType)

      // 遍历文件数组并打印文件名
      for (let i = 0; i < this.images.files.length; i++) {
        const file = this.images.files[i];
        const fileName = file.name;
        console.log(`File ${i + 1} Name: ${fileName}`);
      }

      for (let i = 0; i < this.images.files.length; i++) {
        params.append("files", this.images.files[i])
      }

      // 遍历 FormData 中的数据并打印
      for (const pair of params.entries()) {
        console.log(pair[0], pair[1]);
      }
      console.log("isUseImageName" + this.isUseImageName)
      this.$request.post("/images/uploadImages", params, {
        timeout: 180000, //3分钟
      })
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              console.log("返回结果：" + data.data)

              that.$message.success("添加成功");
              that.$emit('saveStatus', true)
            } else {
              that.showErrorMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        })
      })
    },
    update: function () {
      this.showLoading = true;
      const that = this;
      const params = new FormData()
      params.append("id", this.images.id)
      params.append("tag", this.images.tag)
      params.append("isLock", this.images.isLock)
      // for (let i = 0; i < this.images.files.length; i++) {
      //   params.append("files", this.images.files[i])
      // }
      if (this.images.heat === undefined || this.images.heat === "") {
        this.showErrorMessage("热度不能为空")
        return
      }
      params.append("hot", this.images.heat)
      params.append("categoryId", this.images.categoryId)
      this.$request.post("/images/updateImage", params)
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              that.$message.success("修改成功");
              that.$emit('saveStatus', true)
            } else {
              that.showErrorMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        })
      })
    },
    //添加文字信息
    addFontData: function () {
      this.dialogTitle = "添加文字信息"
      this.isAddImageData = false
      this.showDialog = true
    },
    //添加图片信息
    addImageData: function () {
      this.dialogTitle = "添加图片信息"
      this.isAddImageData = true
      this.showDialog = true
    },
    closeDialog: function () {
      this.templateData = {}
      this.isUpdateTemplateData = false
      this.isAddImageData = false
      this.isLoadDialog = false
    },
    /**
     * 数据保存状态
     * @param info
     */
    saveStatus: function (info) {
      this.showDialog = false
    },
    updateTemplateData: function (data) {
      this.isUpdateTemplateData = true
      this.templateData = data
      if (data.type === 1) {
        this.dialogTitle = "修改图片信息"
        this.showDialog = true
      } else {
        this.dialogTitle = "修改文本信息"
        this.showDialog = true
      }
    },
    delTemplateData: function (id) {
      this.showLoading = true
      const params = new URLSearchParams()
      const that = this;
      params.append("id", id)
      this.$request.post("/autoTemplate/delAutoTemplateById", params)
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              that.$message.success("删除成功");
            } else {
              that.showMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.showMessage("网络错误")
      })
    },
    dialogOpen: function () {
      this.isLoadDialog = true
    },
    /**
     * 处理粘贴事件
     * @param event
     */
    handlePaste: function (event) {
      const items = event.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          if (file) {
            this.processImageFile(file);
          }
          break;
        }
      }
    },
    /**
     * 处理拖拽事件
     * @param event
     */
    handleDrop: function (event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];
        if (file.type.startsWith('image/')) {
          this.processImageFile(file);
        } else {
          this.showErrorMessage("请拖拽图片文件");
        }
      }
    },
    /**
     * 处理图片文件
     * @param file
     */
    processImageFile: function (file) {
      // 检查文件大小
      if (file.size > 2 * 1024 * 1024) {
        this.showErrorMessage("图片文件不能超过2MB");
        return;
      }
      
      // 检查文件类型
      if (!file.type.startsWith('image/')) {
        this.showErrorMessage("请选择图片文件");
        return;
      }
      
      // 检查文件数量限制
      if (this.images.files && this.images.files.length >= 100) {
        this.showErrorMessage("最多只能上传100张图片");
        return;
      }
      
      // 创建预览URL
      const url = URL.createObjectURL(file);
      
      // 创建文件对象
      const fileObj = {
        name: file.name || `pasted_image_${Date.now()}.png`,
        size: file.size,
        type: file.type,
        raw: file,
        url: url
      };
      
      // 添加到文件列表
      if (!this.images.fileList) {
        this.images.fileList = [];
      }
      if (!this.images.files) {
        this.images.files = [];
      }
      
      this.images.fileList.push(fileObj);
      this.images.files.push(file);

      if (!this.isUpdate && this.images.files.length === 1) {
        this.tryAutoFillTagFromImageName(fileObj.name)
      }

      this.$message.success("图片添加成功");
    }
  },
  mounted() {
    if (this.images.heat === undefined) {
      this.$set(this.images, "heat", 4000)
    }

    if (this.images.categoryIds === undefined) {
      this.$set(this.images, "categoryIds", [1, 3, 5])
      this.$set(this.images, "categoryId", 5)

    }
    const that = this
    this.$nextTick(function () {
      that._dialogDropBind = bindDialogFileDrop(that.$el, {
        onDrop: function (event) {
          that.handleDrop(event)
        }
      })
    })
  },
  beforeDestroy() {
    if (this._dialogDropBind) {
      this._dialogDropBind.unbind()
      this._dialogDropBind = null
    }
    // 清理创建的URL对象
    if (this.images.fileList && this.images.fileList.length > 0) {
      this.images.fileList.forEach(file => {
        if (file.url && file.url.startsWith('blob:')) {
          URL.revokeObjectURL(file.url);
        }
      });
    }
  }
}
</script>

<style scoped>
.imageBox {
  width: 100%;
  min-height: 300px;
}

.inputBox {
  max-height: 600px;
  overflow-y: scroll;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.inputBox::-webkit-scrollbar {
  display: none;
}

.btn /deep/ .el-form-item__content {
  margin-left: 0 !important;
  text-align: center;
}

.input {
  width: 300px;
}

.upload-area /deep/ .el-upload-list__item-thumbnail {
  cursor: zoom-in;
}

.operationBox {
  width: 100%;
}
</style>
